<script>
    import { currentUser, signOut } from "../stores/user";
    import Icon from "fa-svelte";
    import { faBars } from "@fortawesome/free-solid-svg-icons";
    import { links } from "svelte-routing";
    import { _ } from "svelte-i18n";
    import { handleAsync } from "../common/safe_promise";

    const handleLogout = handleAsync(() => signOut());
</script>

<header
    class="flex justify-between items-baseline text-blue-500 p-4 border-blue-500
    border-b bg-white"
    use:links>
    <ul class="flex md:space-x-4 items-baseline flex-col md:flex-row">
        <li>
            <a href="/">
                <h1>{$_("Title")}</h1>
            </a>
        </li>
        <li class="md:block relative after-bg-blue hidden">
            <a href="/courses" rel="prefetch">
                <h2>{$_("Courses.Title")}</h2>
            </a>
        </li>
        <li class="md:block relative after-bg-blue hidden">
            <a href="/categories" rel="prefetch">
                <h2>{$_("Categories.Title")}</h2>
            </a>
        </li>
        <li class="md:block relative after-bg-blue hidden">
            <a href="/blog">
                <h2>{$_("Blog.Title")}</h2>
            </a>
        </li>
        <li class="md:block relative after-bg-blue hidden">
            <a href="/assets">
                <h2>{$_("Assets.Title")}</h2>
            </a>
        </li>
        <li class="md:block relative after-bg-blue hidden">
            <a href="/about">
                <h2>{$_("About.Pages")}</h2>
            </a>
        </li>
    </ul>
    {#if $currentUser}
        <div class="logout" on:click={handleLogout}>
            {$currentUser.displayName || "..."}
        </div>
    {/if}
</header>
